import { styled } from '@vw-marketing/us-components';
import { VWTheme } from '../../../../shared/typings/vw-theme';

export const StyledFormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0 auto;
  ${({ theme }: { theme: VWTheme }) => {
    return `
      gap: ${theme.size.static400};
      margin-top: ${theme.size.static400};
    `;
  }}
`;

export const StyledInputsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  & [class^='StyledLabel-'],
  & [class*=' StyledLabel-'] {
    & [class^='StyledTextComponent-'],
    & [class*=' StyledTextComponent-'] {
      display: block;
    }
  }
`;

export const StyledButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: ${({ theme }) => theme.size.static400};
`;

export const InfoboxContainer = styled.div`
  display: flex;
  margin: 40px 0;
`;
